import { render, staticRenderFns } from "./CustomerDashQueue.vue?vue&type=template&id=3624c782&scoped=true"
import script from "./CustomerDashQueue.vue?vue&type=script&lang=js"
export * from "./CustomerDashQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3624c782",
  null
  
)

export default component.exports